import { useMemo } from 'react';
import { SelectOption } from '../../components/form/SelectInput';
import { handleError } from '../gql/config/URQLProvider';
import { useGetSupportedHolidayRegionsQuery } from '../gql/graphql.generated';
import { useSystemSettings } from '../settings/SystemSettingsProvider';

export const useHolidayRegions = () => {
  const [{ data, error }] = useGetSupportedHolidayRegionsQuery();
  if (error) handleError(error);

  return useMemo(() => {
    return (data?.supportedHolidayRegions ?? [])
      .filter((region): region is NonNullable<typeof region> => region != null)
      .map(region => ({
        name: region.displayName,
        value: region.code
      })) as SelectOption[];
  }, [data]);
};

export const useHolidayRegionName = (code?: string | null) => {
  const holidayRegions = useHolidayRegions();

  return useMemo(() => {
    if (!code) {
      return undefined;
    }

    return holidayRegions.find(region => region.value === code)?.name;
  }, [code, holidayRegions]);
};

export const useTenantDefaultHolidayRegionLabel = (fallbackLabel: string, prefix: string) => {
  const defaultHolidayRegionCode = useSystemSettings(state => state.settings.holidayRegion);
  const defaultHolidayRegionName = useHolidayRegionName(defaultHolidayRegionCode);

  return useMemo(() => {
    if (!defaultHolidayRegionName) {
      return fallbackLabel;
    }

    return `${prefix} (${defaultHolidayRegionName})`;
  }, [defaultHolidayRegionName, fallbackLabel, prefix]);
};
